import { ArrowDown, ArrowUp } from 'lucide-react-native';
import React, { memo } from 'react';
import { ScrollView, Text, TouchableOpacity, View } from 'react-native';

import { Color } from '@/styles/GlobalStyles';

import { styles } from './styles';

type SortConfig = {
  key: string;
  direction: 'asc' | 'desc';
} | null;

type IMobileSortControlProps = {
  onSort?: (key: string) => void;
  sortConfig?: SortConfig;
};

const SORT_OPTIONS = [
  { key: 'interview_id', label: 'ID' },
  { key: 'form_name', label: 'Questionário' },
  { key: 'created_at', label: 'Data' },
  { key: 'duration', label: 'Duração' },
  { key: 'mapped_status', label: 'Status' },
];

function MobileSortControlComponent({
  onSort,
  sortConfig,
}: IMobileSortControlProps) {
  return (
    <View style={styles.container}>
      <Text style={styles.label}>Ordenar por:</Text>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.scrollContent}
      >
        {SORT_OPTIONS.map((option) => {
          const isActive = sortConfig?.key === option.key;
          const isAsc = sortConfig?.direction === 'asc';

          return (
            <TouchableOpacity
              key={option.key}
              style={[styles.chip, isActive && styles.activeChip]}
              onPress={() => onSort?.(option.key)}
            >
              <Text
                style={[styles.chipText, isActive && styles.activeChipText]}
              >
                {option.label}
              </Text>
              {isActive &&
                (isAsc ? (
                  <ArrowUp size={12} color={Color.whiteSmoke_100} />
                ) : (
                  <ArrowDown size={12} color={Color.whiteSmoke_100} />
                ))}
            </TouchableOpacity>
          );
        })}
      </ScrollView>
    </View>
  );
}

export const MobileSortControl = memo(MobileSortControlComponent);
